import { DomSanitizer } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';

const { marked } = require('marked');

@Pipe({
  name: 'mdToHtml',
})
export class MdToHtmlPipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}

  original!: string;

  transform(v: string): any {
    const markedParser = marked.setOptions([]);
    this.original = v ? markedParser.parse(v) : '';
    return this._sanitizer.bypassSecurityTrustHtml(this.original);
  }
}
